import { render } from "./CollectionsList.vue?vue&type=template&id=55af36bf"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__